module.exports = __webpack_public_path__ + "img/INTERIOR-FRONX-BOOSTERGREEN-3.189d18d7.jpg";